import {
    CREATE_WASHING_DC_FAILURE_DK,
    CREATE_WASHING_DC_REQUEST_DK,
    CREATE_WASHING_DC_SUCCESS_DK,
    CREATE_USER_FORM_WASHING_DC_DK,
    FETCH_SINGLE_WASHING_DC_FAILURE_DK,
    FETCH_SINGLE_WASHING_DC_REQUEST_DK,
    FETCH_SINGLE_WASHING_DC_SUCCESS_DK,
    FETCH_WASHING_DC_FAILURE_DK,
    FETCH_WASHING_DC_REQUEST_DK,
    FETCH_WASHING_DC_SUCCESS_DK,
    NAVIGATE_WASHING_DC_DETAILS_DK,
    NAVIGATE_WASHING_DC_DK,
    WASHING_DC_USERFORM_RESET_DK,
    UPDATE_WASHING_DC_FAILURE_DK,
    UPDATE_WASHING_DC_REQUEST_DK,
    UPDATE_WASHING_DC_SUCCESS_DK,
    DELETE_WASHING_DC_REQUEST_DK,
    DELETE_WASHING_DC_SUCCESS_DK,
    DELETE_WASHING_DC_FAILURE_DK,
    WASHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    WASHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_WASHING_DC_INVOICE_REQUEST,
    FETCH_WASHING_DC_INVOICE_SUCCESS,
    FETCH_WASHING_DC_INVOICE_FAILURE,
    RESET_WASHING_DC_INVOICE,
    FETCH_WASHING_DC_STYLE_REQUEST_DK,
    FETCH_WASHING_DC_STYLE_SUCCESS_DK,
    FETCH_WASHING_DC_STYLE_FAILURE_DK
} from './washingDC.actionsType';

export const WASHING_DC_DK = 'washingDcDK';

let initialState = {
    loading: false,
    washingDC: [],
    washingDCInvoice: [],
    washingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedDyeingDC: {},
    detailsId: '',
    activeKey: 1,
    isDyeingDC: false,
    washingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let washingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_WASHING_DC_REQUEST_DK:
        case FETCH_WASHING_DC_STYLE_REQUEST_DK:
        case FETCH_WASHING_DC_INVOICE_REQUEST:
        case CREATE_WASHING_DC_REQUEST_DK:
        case FETCH_SINGLE_WASHING_DC_REQUEST_DK:
        case UPDATE_WASHING_DC_REQUEST_DK:
        case DELETE_WASHING_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_WASHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingDC: updatePayload
            };
        case FETCH_WASHING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingDCStyle: updatePayload?.PONO
            };
        case FETCH_WASHING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                washingDCInvoice: updatePayload
            };

        case CREATE_WASHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_WASHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedDyeingDC: updatePayload,
                userform: updatePayload
            };
        case UPDATE_WASHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedDyeingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_WASHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedDyeingDC: {}
            };
        case FETCH_WASHING_DC_FAILURE_DK:
        case FETCH_WASHING_DC_STYLE_FAILURE_DK:
        case FETCH_WASHING_DC_INVOICE_FAILURE:
        case FETCH_SINGLE_WASHING_DC_FAILURE_DK:
        case CREATE_WASHING_DC_FAILURE_DK:
        case UPDATE_WASHING_DC_FAILURE_DK:
        case DELETE_WASHING_DC_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_WASHING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case WASHING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedDyeingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_WASHING_DC_DETAILS_DK:
            return {
                ...state,
                isDyeingDC: true,
                washingDCSelectedValue: updatePayload.washingDCSelectedValue
            };
        case NAVIGATE_WASHING_DC_DK:
            return {
                ...state,
                isDyeingDC: false
            };
        case RESET_WASHING_DC_INVOICE:
            return {
                ...state,
                washingDCInvoice: []
            };
        case WASHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case WASHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
